import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { useSnackbar } from "notistack";

import { Grid } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
// import AddIcon from "@mui/icons-material/Add";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DeleteIcon from "@mui/icons-material/Delete";

import { updateShippingOrder } from "src/api/shippingOrder";

import device from "src/styles/device";
import font from "src/styles/font";
import { checkNotEmpty } from "src/common";
import {
  Black,
  DarkGrey,
  Grey,
  GreyStroke,
  Primary,
  White01,
} from "src/styles/color";

import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
// import UploadImage from "src/components/upload/dropzone/UploadImage";
import UploadMultiImage from "src/components/upload/dropzone/UploadMultiImage";

import { SpanLabel } from "src/modules/order/shipping-order/components";

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root {
    color: ${Black};
  }
`;

const Dragger = styled.div`
  width: 100%;
  padding: 24px 16px;
  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; */
  border-radius: 16px;
  border: 1px dashed ${GreyStroke};
  text-align: center;
  background-color: #faf9f9;

  &:hover {
    border: 1px dashed ${Primary};
    cursor: pointer;
  }

  @media ${device.mobileL} {
    padding: 16px;
    border-radius: 8px;
  }
`;

const WrapperIconUpload = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 8px 8px;
  margin: 0 auto;
  background-color: ${White01};
`;

const TextDragger = styled.p`
  width: 100%;
  margin: 4px 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: ${DarkGrey};

  span {
    font-size: 0.875rem;
    font-weight: 600;
    color: ${Black};
  }

  :first-of-type {
    margin-top: 12px;
  }

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const UploadItem = styled.div`
  width: 100%;
  padding: 12px;
  border: 1px solid ${Grey};
  border-radius: 16px;

  @media ${device.mobileL} {
    padding: 8px;
    border-radius: 8px;
  }
`;

const PreviewImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;

  @media ${device.mobileL} {
    width: 60px;
    height: 60px;
    border-radius: 4px;
  }
`;

const PreviewImageTitle = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  line-height: 24px;
  color: Black;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
  }
`;

// const WrapperUploadImage = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const WrapperImgSlip = styled.div`
//   width: 100%;
//   padding: 20px 100px;
//   border: 1px dashed #e13b30;
//   border-radius: 16px;
//   height: auto;
// `;

// const ImgSlip = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: contain;
// `;

const StyledDialog = muiStyled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    padding: 24,
    paddingTop: 0,
  },
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: 640,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
  "& .MuiDialogActions-root>:not(:first-of-type)": {
    marginLeft: 24,
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiPaper-root": {
      margin: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 16,
      paddingTop: 0,
    },
    "& .MuiDialogActions-root": {
      padding: 16,
    },
  },
}));

const DeliveryProofImgDialog = ({
  onClose,
  onSuccess,
  orderDetail,
  mode = "add",
  setIsLoading,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const initialDetail = {
    order: {},
    method: "ส่งไปถึงลูกค้าโดยตรง",
    fulfillmentProcess: [
      {
        type: "มีค่าจัดส่ง",
        carrier: "จัดส่งโดยร้านค้า",
        trackingNumber: null,
        trackingUrl: null,
        shippingFee: null,
        pickupAddress: {
          name: null,
          tel: null,
          address: null,
          coordinates: {
            lat: null,
            lng: null,
          },
        },
        shippingProofs: [],
        deliveryProofs: [],
        shippedDate: null,
        estimatedDeliveryDate: null,
        actualDeliveryDate: null,
        remark: null,
      },
    ],
    payment: {
      method: null,
      info: {
        bankAccountName: null,
        bankNo: null,
      },
      total: null,
      paymentDate: null,
      paymentProof: null,
    },
    status: {
      failureReason: null,
      value: "pending",
    },
    note: null,
    documents: {
      customer: {
        qt: {
          qtDate: null,
          qtNo: null,
          customerQtFile: null,
          customerQtAdditionalFile: null,
        },
        inv: {
          invDate: null,
          invNo: null,
          customerInvFile: null,
          customerInvAdditionalFile: null,
        },
      },
      xsurface: {
        po: {
          poDate: null,
          poNo: null,
          xsurfacePoFile: null,
          xsurfacePoAdditionalFile: null,
        },
        vc: {
          vcDate: null,
          vcNo: null,
          xusrfaceVcFile: null,
          xsurfaceVcAdditionalFile: null,
        },
      },
      seller: {
        qt: {
          qtDate: null,
          qtNo: null,
          sellerQtFile: null,
          sellerQtAdditionalFile: null,
        },
        inv: {
          invDate: null,
          invNo: null,
          sellerInvFile: null,
          sellerInvAdditionalFile: null,
        },
      },
    },
  };
  const [shippingDetail, setShippingDetail] = useState(initialDetail);

  useEffect(() => {
    if (!!orderDetail) {
      setShippingDetail({
        ...orderDetail,
        fulfillmentProcess:
          orderDetail.fulfillmentProcess.length > 0
            ? orderDetail.fulfillmentProcess
            : initialDetail.fulfillmentProcess,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail]);

  const handleDeleteImg = (imgIndex) => {
    setShippingDetail((prevState) => {
      const updateShipping = [...prevState.fulfillmentProcess];
      const updateDeliveryProof = [...updateShipping[0].deliveryProofs];

      updateDeliveryProof.splice(imgIndex, 1);

      updateShipping[0] = {
        ...updateShipping[0],
        ...{ deliveryProofs: updateDeliveryProof },
      };
      return {
        ...prevState,
        fulfillmentProcess: updateShipping,
      };
    });
  };

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = {
        ...shippingDetail,
        order: shippingDetail?.order?._id,
      };

      const data = new FormData();
      for (const field in payload) {
        if (
          field === "order" ||
          field === "_id" ||
          field === "method" ||
          field === "note" ||
          field === "seller"
        ) {
          data.append(field, payload[field]);
        } else {
          data.append(field, JSON.stringify(payload[field]));
        }
      }

      if (payload?.fulfillmentProcess[0]?.deliveryProofs?.length > 0) {
        payload?.fulfillmentProcess[0]?.deliveryProofs?.map((item, index) =>
          data.append(
            `fulfillmentProcess.0.deliveryProofs.${index}.deliveryProof`,
            item,
          ),
        );
      }
      // if (!!payload?.fulfillmentProcess[0]?.deliveryProof) {
      //   data.append(
      //     "fulfillmentProcess.0.deliveryProof",
      //     payload.fulfillmentProcess[0].deliveryProof,
      //   );
      // }
      delete data.documents;

      let fulfillmentProcess = JSON.parse(data.get("fulfillmentProcess"));
      if (fulfillmentProcess?.[0]?.shippingProofs?.length > 0) {
        let formatShippingProofs = fulfillmentProcess?.[0]?.shippingProofs;

        formatShippingProofs?.map((item, index) => {
          let format = item;
          format.shippingProof = item?.shippingProof?._id;
          return format;
        });

        fulfillmentProcess[0] = {
          ...fulfillmentProcess[0],
          ...{ shippingProofs: formatShippingProofs },
        };
      }
      delete fulfillmentProcess[0].deliveryProofs;
      data.set("fulfillmentProcess", JSON.stringify(fulfillmentProcess));

      await updateShippingOrder(orderDetail._id, data);
      await onSuccess();
      enqueueSnackbar(`อัพเดทข้อมูลใบเสนอราคา สำเร็จ`, {
        variant: "success",
      });
    } catch (err) {
      console.error("err:", err);
      enqueueSnackbar(err?.response?.data?.message, {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = () => {
    // return shippingDetail?.fulfillmentProcess?.[0]?.deliveryProofs;
    return (
      shippingDetail?.fulfillmentProcess?.[0]?.deliveryProofs &&
      shippingDetail?.fulfillmentProcess?.[0]?.deliveryProofs?.length > 0
    );
  };

  return (
    <StyledDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogTitle
        sx={{
          p: {
            sm: 3,
            xs: 2,
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          fontSize: {
            sm: font.size.lg,
            xs: font.size.md,
          },
          fontWeight: 600,
        }}
      >
        {mode === "add" ? "เพิ่มรูปภาพ" : "แก้ไขรูปภาพ"}
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item xs={12}>
            <SpanLabel>
              รูปแพ็คสินค้าก่อนจัดส่ง <span>(สูงสุด 3 รูป)</span>
            </SpanLabel>
          </Grid>

          <Grid item xs={12}>
            {/* <UploadImage
              callBackFile={(fileCallBlack) => {
                fileCallBlack !== "" &&
                  setShippingDetail((prevState) => {
                    const updateShipping = [...prevState.fulfillmentProcess];
                    updateShipping[0] = {
                      ...updateShipping[0],
                      ...{ deliveryProof: fileCallBlack },
                    };
                    return {
                      ...prevState,
                      fulfillmentProcess: updateShipping,
                    };
                  });
              }}
              closeAlert={false}
            >
              {checkNotEmpty(
                shippingDetail?.fulfillmentProcess[0]?.deliveryProof,
              ) ? (
                <WrapperUploadImage>
                  <WrapperImgSlip>
                    <ImgSlip
                      src={
                        shippingDetail?.fulfillmentProcess[0]?.deliveryProof
                          .fileData
                      }
                      alt="paySlipImage"
                    />
                  </WrapperImgSlip>
                </WrapperUploadImage>
              ) : (
                <WrapperUploadImage>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<AddIcon />}
                    sx={{ width: "100%" }}
                  >
                    แนบรูปสินค้า
                  </Button>
                </WrapperUploadImage>
              )}
            </UploadImage> */}
            <UploadMultiImage
              callBackFile={(fileCallBlack) => {
                fileCallBlack !== "" &&
                  setShippingDetail((prevState) => {
                    const updateShipping = [...prevState.fulfillmentProcess];

                    let updateDeliveryProof = [
                      ...(updateShipping[0].deliveryProofs || []),
                    ];

                    if (
                      updateShipping[0].deliveryProofs?.length +
                        fileCallBlack?.length >
                      3
                    ) {
                      enqueueSnackbar(`Number of files is more than 3.`, {
                        variant: "error",
                      });
                    } else {
                      updateDeliveryProof = [
                        ...updateDeliveryProof,
                        ...fileCallBlack,
                      ];
                    }

                    updateShipping[0] = {
                      ...updateShipping[0],
                      ...{ deliveryProofs: updateDeliveryProof },
                    };
                    return {
                      ...prevState,
                      fulfillmentProcess: updateShipping,
                    };
                  });
              }}
              closeAlert={false}
              limitFile={3}
              isDisabled={
                shippingDetail?.fulfillmentProcess?.[0]?.deliveryProofs
                  ?.length >= 3
              }
            >
              <Dragger>
                <WrapperIconUpload>
                  <FileUploadIcon sx={{ color: Black }} />
                </WrapperIconUpload>
                <TextDragger>
                  <span>กดเพื่ออัปโหลด</span> หรือลากวาง
                </TextDragger>
                <TextDragger>jpg, png, jpeg</TextDragger>
                <TextDragger>(Max. File size: 4 MB)</TextDragger>
              </Dragger>
            </UploadMultiImage>
          </Grid>

          {checkNotEmpty(
            shippingDetail?.fulfillmentProcess?.[0]?.deliveryProofs,
          ) && (
            <Grid item xs={12} container spacing={1}>
              {shippingDetail?.fulfillmentProcess?.[0]?.deliveryProofs.map(
                (img, index) => (
                  <Grid item xs={12}>
                    <UploadItem>
                      <Grid
                        container
                        spacing={{ xs: 1, md: 2 }}
                        alignItems="center"
                      >
                        <Grid
                          item
                          xs="auto"
                          sx={{
                            maxHeight: { xs: "68px", sm: "88px", md: "96px" },
                          }}
                        >
                          <PreviewImage
                            src={img?.fileData}
                            alt={`deliveryProof-${index}`}
                          />
                        </Grid>

                        <Grid item xs>
                          <PreviewImageTitle>{img?.path}</PreviewImageTitle>
                        </Grid>

                        <Grid item xs="auto">
                          <IconButton onClick={() => handleDeleteImg(index)}>
                            <DeleteIcon sx={{ color: Grey }} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </UploadItem>
                  </Grid>
                ),
              )}
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          onClick={() => onClose()}
          fullWidth
          sx={{ maxWidth: { xs: 135.5, sm: 180 }, height: { xs: 32, sm: 48 } }}
        >
          ยกเลิก
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit()}
          fullWidth
          sx={{ maxWidth: { xs: 135.5, sm: 180 }, height: { xs: 32, sm: 48 } }}
          disabled={!isFormValid()}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default DeliveryProofImgDialog;
